import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { Tile } from '../../interfaces/routering/tile';

@Injectable()

export class TileService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<Tile[] | boolean> {
    return new Observable<Tile[] | boolean>((o: Subscriber<Tile[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.tiles.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Tile[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<Tile | boolean> {
    return new Observable<Tile | boolean>((o: Subscriber<Tile | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('routering.tiles.read', {':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Tile>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('routering.tiles.update', {':id': id}), formData);
  }
}
